import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectionButtonGroup } from '../Selection-button-group/Selection-button-group';
import { Loading, Tabs } from '../UI';

import { CreateStrategyAssetCategory } from '../NewStrategy/types';
import { UpgradeSubscription } from '../UpgradeSubscription/UpgradeSubscription';
import { useAuth } from '../../context/Auth';
import { useModalContext } from '../../context/Modal';
import { FormValues } from './types';
import { FormikProps } from 'formik';
import { logger } from '../../helpers/logger';
import {
  ConnectionTypeEnum,
  MembershipPlanSkuEnum,
} from '../../constants/enums';

export const ChooseConnectionAndAssetCategory = ({
  assetCategorySelection,
  categories,
  connectionType,
  formik,
  loading,
  onAssetCategorySelectionChange = () => {},
  setConnectionType,
  skipStrategy,
}: {
  assetCategorySelection?: CreateStrategyAssetCategory;
  categories: CreateStrategyAssetCategory[];
  connectionType: ConnectionTypeEnum;
  formik: FormikProps<FormValues>;
  loading: boolean;
  onAssetCategorySelectionChange: (
    assetCategory: CreateStrategyAssetCategory
  ) => any;
  setConnectionType: React.Dispatch<React.SetStateAction<ConnectionTypeEnum>>;
  skipStrategy?(): void;
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { closeModal } = useModalContext();

  logger.log(
    'ChooseAssetCategory',
    assetCategorySelection?.type,
    connectionType,
    assetCategorySelection?.title
  );

  const requireSubscriptionUpgrade = useMemo(() => {
    return (
      !user ||
      (connectionType !== ConnectionTypeEnum.MANUAL &&
        user.membership.membershipPlan.sku === MembershipPlanSkuEnum.Camelot) ||
      (user.membership.membershipPlan.features.portfolioImport !== -1 &&
        user.membership.membershipPlan.features.portfolioImport <=
          formik.values.portfolioImport)
    );
  }, [user, formik.values.portfolioImport, connectionType]);

  return (
    <div
      className={`
        flex
        flex-col
        flex-grow-1
        w-full
        min-h-0
        border-t
        border-grey-10
        dark:border-grey-80
      `}
    >
      <Tabs
        className="w-full"
        items={Object.values(ConnectionTypeEnum).map((connection) => {
          return {
            label: t(`strategies.addAsset.title.${connection}`),
            value: connection,
          };
        })}
        currentValue={connectionType}
        onClick={(val) => setConnectionType(val as ConnectionTypeEnum)}
      />

      {requireSubscriptionUpgrade ? (
        <div className="flex h-full">
          <UpgradeSubscription
            className="h-full"
            viewMode="card"
            feature="COMMON"
            onCloseClick={() => onAssetCategorySelectionChange(categories[0])}
            onUpgradeClick={() => {
              closeModal();
              skipStrategy?.();
            }}
          />
        </div>
      ) : (
        <div className="flex flex-col items-center flex-grow-1 w-full overflow-auto pt-5">
          <Loading status={loading} />

          <span className="text-md font-medium ml-7 mr-auto">
            {t(`strategies.addAsset.subTitle.${connectionType}`)}
          </span>
          <SelectionButtonGroup
            className="mt-5 mb-20 px-6 w-full"
            selectionList={categories}
            cols={2}
            currentSelection={assetCategorySelection}
            setCurrentSelection={onAssetCategorySelectionChange}
          />
        </div>
      )}
    </div>
  );
};
